module.exports = __webpack_public_path__ + "img/room.090fad84.svg";